import { render } from "./zqTopicInfo.vue?vue&type=template&id=5142f229&scoped=true"
import script from "./zqTopicInfo.vue?vue&type=script&lang=js"
export * from "./zqTopicInfo.vue?vue&type=script&lang=js"

import "./zqTopicInfo.vue?vue&type=style&index=0&id=5142f229&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5142f229"]])

export default __exports__